import { NotFoundPage } from '@axilon-apps/libs-ui-dashboard'
import { useDebugMode } from '../../lib/debug-mode'

interface DebugRouteProps {
  children: React.ReactNode
  /** Where to send users when debug mode is off. Defaults to Plant. */
  fallbackHref?: string
}

/**
 * Wrapper that renders its `children` only when runtime config, the stored
 * preference, and effective debug authorization all allow it. Otherwise it
 * renders the standard `NotFoundPage`, matching the router-level catch-all
 * behavior.
 */
export function DebugRoute({ children, fallbackHref = '/plant' }: DebugRouteProps) {
  const enabled = useDebugMode()
  if (!enabled) return <NotFoundPage href={fallbackHref} />
  return children
}

export default DebugRoute
